import { PaddingType } from 'common/types/styleTypes'
import {
  backgroundColorCss,
  borderCss,
  boxShadowCss,
  colorCss,
  FontProps,
  fontCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileColorCss,
  mobileFontCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'

type TextAreaUiProps = BorderEntityInterface & {
  height: number
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  backgroundColor: string
  mobileBackgroundColor?: string
  boxShadow?: string
  mobileBoxShadow?: string
} & FontProps

const TextAreaUi = styled.textarea<TextAreaUiProps>`
  height: ${p => p.height}px;
  width: 100%;
  font-family: inherit;
  font-weight: inherit;
  font-style: inherit;
  appearance: none;
  resize: vertical;
  max-height: 100vh;
  &::placeholder {
    ${colorCss}
  }
  ${fontCss}
  ${backgroundColorCss}
  ${borderCss}
  ${boxShadowCss}
  ${paddingsCss}
  ${p => p.theme.phone} {
    ${mobileFontCss}
    ${mobileBorderCss}
    ${mobileBackgroundColorCss}
    ${mobileBoxShadowCss}
    ${mobilePaddingsCss}
    &::placeholder {
      ${mobileColorCss}
    }
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
      ${mobileBackgroundColorCss}
      ${mobileBorderCss}
      ${mobileBoxShadowCss}
      ${mobilePaddingsCss}
      &::placeholder {
        ${mobileColorCss}
      }
    `}
`

export default TextAreaUi
